import * as React from "react";
import PropTypes from 'prop-types';

const SvgChatFill = props => {
  if (props.id !== "_svgchatfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path d="M224 80H120c-11.028 0-20 8.523-20 19v57c0 11.402 8.598 20 20 20h39.148l.134.092 35.557 34.23a6.002 6.002 0 006.511 1.199A6 6 0 00205 206l.009-30H220c.116 0 .232-.003.35-.01 5.141-.301 10.115-2.816 14.012-7.086 3.531-3.869 5.64-8.693 5.64-12.904V98C240 86.733 231.865 80 224 80z" /><path d="M120 74h48V46c0-9.925-7.626-18-17-18H17C7.626 28 0 36.075 0 46v72c0 10.292 7.703 18.986 16.821 18.986h25.855c.39 0 1.001.281 1.324.547V166a6 6 0 0010.064 4.413l36.279-33.414 3.656-.003V99H94c0-13.785 11.664-25 26-25z" /></svg>;
};

SvgChatFill.displayName = "_svgchatfill";
SvgChatFill.propTypes = {
  id: PropTypes.string
};
SvgChatFill.defaultProps = {
  id: ''
};
export default SvgChatFill;